<template>
  <pack>
    <div v-if="showTemplate">
      <zt-title>代码模板库</zt-title>
      <zt-button type="primary" size="large" @click="showTemplate=false">代码草稿箱</zt-button>

      <!-- 搜索器 -->
      <form class="form" @submit.native.prevent @keyup.enter.exact="templateSearch">
        <span>小程序名称：</span>
        <zt-input placeholder="请输入小程序名称" v-model.trim="templateData.search.source_miniprogram"></zt-input>

        <span>模板ID：</span>
        <zt-input placeholder="请输入模板ID" v-model.trim="templateData.search.template_id"></zt-input>

        <span>版本号：</span>
        <el-select v-model="templateData.search.user_version" placeholder="请选择">
          <el-option
            v-for="item in templateVersionList"
            :key="item.value"
            :label="item.label"
            v-model="item.value"
          ></el-option>
        </el-select>

        <zt-button type="primary" @click="templateSearch">搜索</zt-button>
        <zt-button @click="templateClear">清空</zt-button>
      </form>

      <!-- table -->
      <el-table :data="templateList" ref="table" class="table" :load="templateData.loading">
        <el-table-column label="模板ID" prop="template_id" width="60px" />
        <el-table-column label="开发人员" prop="developer" width="70px" />
        <el-table-column label="版本号" prop="user_version"></el-table-column>
        <el-table-column label="版本描述" prop="user_desc"></el-table-column>
        <el-table-column label="小程序名称" prop="source_miniprogram" />
        <el-table-column label="APPID" prop="source_miniprogram_appid" />
        <el-table-column label="添加时间">
          <template slot-scope="{row}">{{formatDate(row.create_time*1000)}}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <zt-button
              size="mini"
              v-if="(row.template_id!=autoModelTemplateId)&&autoModel"
              @click="templateChoose(row)"
            >设为自动开发模板</zt-button>
            <zt-button
              size="mini"
              v-if="(row.template_id==autoModelTemplateId)&&autoModel"
              @click="templateCancel(row)"
            >取消设为自动开发模板</zt-button>
            <zt-button
              size="mini"
              type="danger"
              :disabled="row.template_id==autoModelTemplateId"
              @click="templateDel(row)"
            >删除</zt-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- switch -->
      <div class="switch">
        <span>自动开发模式</span>
        <el-switch
          v-model="autoModel"
          @change="autoModelChange"
          active-color="#4CD964"
          inactive-color="#eee"
        ></el-switch>
        <p>* 淘客成功授权后小程序的首次开发实现自动发布</p>
        <p>* 如果未设置自动开发模版，则默认使用最新的</p>
      </div>
    </div>
    <div v-else>
      <zt-title>代码库-草稿箱</zt-title>
      <zt-button type="primary" size="large" @click="showTemplate=true">代码模板库</zt-button>

      <!-- 搜索器 -->
      <form class="form" @submit.native.prevent @keyup.enter.exact="draftSearch">
        <span>小程序名称：</span>
        <zt-input placeholder="请输入小程序名称" v-model.trim="draftData.search.source_miniprogram"></zt-input>

        <span>模板ID：</span>
        <zt-input placeholder="请输入模板ID" v-model.trim="draftData.search.draft_id"></zt-input>

        <span>版本号：</span>
        <el-select v-model="draftData.search.user_version" placeholder="请选择">
          <el-option
            v-for="item in draftVersionList"
            :key="item.label"
            :label="item.label"
            v-model="item.label"
          ></el-option>
        </el-select>

        <zt-button type="primary" @click="draftSearch">搜索</zt-button>
        <zt-button @click="draftClear">清空</zt-button>
      </form>

      <!-- table -->
      <el-table :data="draftList" ref="table" class="table" :load="draftData.loading">
        <el-table-column label="模板ID" prop="draft_id" width="60px" />
        <el-table-column label="开发人员" prop="developer" width="70px" />
        <el-table-column label="版本号" prop="user_version"></el-table-column>
        <el-table-column label="版本描述" prop="user_desc"></el-table-column>
        <el-table-column label="小程序名称" prop="source_miniprogram" />
        <el-table-column label="APPID" prop="source_miniprogram_appid" />
        <el-table-column label="添加时间">
          <template slot-scope="{row}">{{formatDate(row.create_time*1000)}}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <zt-button size="mini" @click="draftDataAdd(row)">添加至模板库</zt-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </pack>
</template>

<script>
import {
  admin_plugin_wxapp_api,
  admin_plugin_wxapp_dev_auto,
  admin_plugin_wxapp_dev_template_id
} from '@/api/program';
import { getConfig } from '@/api/config';
import { formatDate } from '@/utils/date';

export default {
  name: 'codeTemplate',
  data: () => ({
    autoModelTemplateId: '',
    autoModel: false,
    showTemplate: true,
    template_list: [],
    templateList: [],
    draft_list: [],
    draftList: [],
    templateData: {
      loading: false,
      search: {
        source_miniprogram: '',
        template_id: '',
        user_version: -1,
      },
      onlineList: [
        {
          label: '2020-1',
          value: 0,
        },
        {
          label: '2020-1',
          value: 1,
        },
      ],
    },
    draftData: {
      loading: false,
      search: {
        source_miniprogram: '',
        draft_id: '',
        user_version: -1,
      },
      onlineList: [
        {
          label: '2020-1',
          value: 0,
        },
        {
          label: '2020-1',
          value: 1,
        },
      ],
    },
  }),
  computed: {
    templateVersionList: (vm) => {
      let list = [
        {
          value: -1,
          label: '全部',
        },
      ];
      vm.template_list.map((arr) => {
        list.push({
          value: arr.template_id,
          label: arr.user_version,
        });
      });
      return list;
    },
    draftVersionList: (vm) => {
      let list = [
        {
          value: -1,
          label: '全部',
        },
      ];
      vm.draft_list.map((arr) => {
        list.push({
          value: arr.template_id,
          label: arr.user_version,
        });
      });
      return list;
    },
    latelyTemplate: (vm) => {
      let time = 0;
      let lately = {};
      vm.template_list.map((arr) => {
        if (arr.create_time > time) {
          lately = arr;
        }
      });
      return lately;
    },
  },
  mounted() {
    this.getTemplateList();
    this.getDraftList();
    this.getAutoModel();
    this.getAutoModelTemplate();
  },
  methods: {
    formatDate,
    getAutoModel() {
      getConfig({ key: 'plugin_wxapp_dev_auto' }).then(({ data }) => {
        if (data.error_code == 0) {
          this.autoModel = data.value == 1;
        } else {
          this.$message.error(this.data.error_message);
        }
      });
    },
    getAutoModelTemplate() {
      getConfig({ key: 'plugin_wxapp_dev_template_id' }).then(({ data }) => {
        if (data.error_code == 0) {
          this.autoModelTemplateId = data.value;
        } else {
          this.$message.error(this.data.error_message);
        }
      });
    },
    autoModelChange(val) {
      admin_plugin_wxapp_dev_auto({ value: val ? 1 : 0 }).then(({ data }) => {
        if (data.error_code != 0) {
          this.$message.error(data.error_message);
        }
        if (!val) {
          this.getAutoModelTemplate();
        }
      });
    },
    getTemplateList() {
      let params = {
        url:
          'https://api.weixin.qq.com/wxa/gettemplatelist?access_token=COMPONENT_ACCESS_TOKEN',
      };
      admin_plugin_wxapp_api(params).then(({ data }) => {
        if (data.error_code == 0 && data.result.errcode == 0) {
          this.template_list = data.result.template_list;
          this.templateList = this.template_list.slice(0);
        } else if (data.error_code) {
          this.$message.error(data.error_message);
        } else {
          this.$message.error(data.result.errmsg);
        }
      });
    },
    getDraftList() {
      let params = {
        url:
          'https://api.weixin.qq.com/wxa/gettemplatedraftlist?access_token=COMPONENT_ACCESS_TOKEN',
      };
      admin_plugin_wxapp_api(params).then(({ data }) => {
        if (data.error_code == 0 && data.result.errcode == 0) {
          this.draft_list = data.result.draft_list;
          this.draftList = this.draft_list.slice(0);
        } else if (data.error_code) {
          this.$message.error(data.error_message);
        } else {
          this.$message.error(data.result.errmsg);
        }
      });
    },
    templateSearch() {
      // 操作templateList
      const { search } = this.templateData;
      this.templateList = this.template_list.filter((arr) => {
        return (
          (!search.source_miniprogram ||
            search.source_miniprogram == arr.source_miniprogram) &&
          (!search.template_id || search.template_id == arr.template_id) &&
          (search.user_version == -1 || search.user_version == arr.user_version)
        );
      });
    },
    draftSearch() {
      let { search } = this.draftData;
      this.draftList = this.draft_list.filter((arr) => {
        return (
          (!search.source_miniprogram ||
            search.source_miniprogram == arr.source_miniprogram) &&
          (!search.draft_id || search.draft_id == arr.draft_id) &&
          (search.user_version == -1 || search.user_version == arr.user_version)
        );
      });
    },
    templateClear() {
      this.$set(this.templateData, 'search', {
        source_miniprogram: '',
        template_id: '',
        user_version: -1,
      });
      this.templateSearch();
    },
    draftClear() {
      this.$set(this.draftData, 'search', {
        source_miniprogram: '',
        draft_id: '',
        user_version: -1,
      });
      this.draftSearch();
    },
    templateChoose(row) {
      this.$confirm('确定将模板设置为自动开发模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          admin_plugin_wxapp_dev_template_id({
            value: row.template_id,
          }).then(({ data }) => {
            if (data.error_code == 0) {
              this.$message.success('设置自动开发模板成功');
              this.getAutoModelTemplate();
            } else {
              this.$message.error(data.error_message);
            }
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    templateCancel() {
      this.$confirm('确定将模板取消设置为自动开发模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          admin_plugin_wxapp_dev_template_id({
            value: -1,
          }).then(({ data }) => {
            if (data.error_code == 0) {
              this.$message.success('取消设置为自动开发模板成功');
              // 取消后没有自动开发模板，则关闭自动开发模式
              admin_plugin_wxapp_dev_auto({ value: 0 }).then(() => {
                // 刷新自动开发模式数据
                this.getAutoModel();
              });
            } else {
              this.$message.error(data.error_message);
            }
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    templateDel(row) {
      let params = {
        url:
          'https://api.weixin.qq.com/wxa/deletetemplate?access_token=COMPONENT_ACCESS_TOKEN',
        data: JSON.stringify({
          template_id: row.template_id,
        }),
      };
      this.$confirm('确定删除该模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        admin_plugin_wxapp_api(params).then(({ data }) => {
          if (data.error_code == 0) {
            this.$message.success('删除模板成功');
            this.getTemplateList();
          } else {
            this.$message.error(data.error_message);
          }
        });
      });
    },
    draftDataAdd(row) {
      let params = {
        url:
          'https://api.weixin.qq.com/wxa/addtotemplate?access_token=COMPONENT_ACCESS_TOKEN',
        data: JSON.stringify({
          draft_id: row.draft_id,
        }),
      };
      this.$confirm('确定将草稿添加到模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          admin_plugin_wxapp_api(params).then(({ data }) => {
            if (data.error_code == 0 && data.result.errcode == 0) {
              this.$message.success('添加到模板成功');
              //刷新数据
              this.getTemplateList();
            } else if (data.error_code) {
              this.$message.error(data.error_message);
            } else {
              this.$message.error(data.result.errmsg);
            }
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
.table {
  margin-top: 30px;
}
.form {
  margin-top: 30px;
  font-size: 12px;
  span {
    display: inline-block;
    margin-left: 15px;
    margin-right: 5px;
  }

  /deep/ .zt-input {
    width: 150px;
    margin-right: 15px;
  }
  /deep/ .el-select {
    width: 139px;
  }
  /deep/ .zt-button {
    margin-left: 20px;
  }
}
.switch {
  text-align: center;
  vertical-align: middle;
  position: absolute;
  right: 32px;
  top: 40px;
  line-height: 30px;
  font-size: 12px;
  span {
    font-size: 16px;
    vertical-align: middle;
    margin-right: 15px;
  }
  p {
    color: $theme;
  }
}
</style>